<script lang="ts" setup>
  import { onMounted, shallowRef } from 'vue';
  import { LivePlayerProps } from './live-player';
  import XgPlayer from './xgPlayer.vue';
  import YsPlayer from './ysPlayer.vue';

  defineOptions({
    name: 'ILivePlayer',
  });

  const props = defineProps(LivePlayerProps);
  const comp = shallowRef();
  const compRef = shallowRef();

  onMounted(() => {
    // 当访问令牌存在时，使用萤石云播放器(YsPlayer)
    // 否则使用西瓜播放器(XgPlayer)
    comp.value = props.accessToken && props.accessToken.length > 32 ? YsPlayer : XgPlayer;
  });

  defineExpose({
    play(options?: any) {
      compRef.value?.play(options);
    },
    destroy() {
      compRef.value?.destroy();
    },
    resize() {
      compRef.value?.resize();
    },
  });
</script>

<template>
  <div class="i-player-bg i-player-container">
    <component :is="comp" ref="compRef" v-bind="props" />
  </div>
</template>
